export const GoogleMapsAPI = 'AIzaSyAwcOSQ6hnqoqiXX_1D1ykHOBAZZ2UorHE';
export const DefaultLatLng = { lat: 24.7135517, lng: 46.6752957 };
export const GoogleMapLibrary = ["places", "geometry", "visualization", "drawing"];
